import { createAsyncThunk } from "@reduxjs/toolkit";
import { FORGOTPASSWORD_API_URL } from "@custom/constant";
import { ForgotPasswordFormTypes } from "../../Auth/helper/auth";

 const forgotPasswordApi = createAsyncThunk('login', async (forgotPasswordData: ForgotPasswordFormTypes) => {
  const response = await fetch(FORGOTPASSWORD_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(forgotPasswordData),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Login failed');
  }
  return data;
});

export default forgotPasswordApi;
